import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormIndicatorPending(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="#E1943E"
      />
      <path
        d="M15 7H9v2.23L11.571 12 9 14.77V17h6v-2.23L12.429 12 15 9.692V7Z"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
}
